export enum AppAccessStatus {
  Access,
  Active,
  InActive,
  RequiresAction
}
